import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { DpTableComponent } from '../common-component/dp-table/dp-table.component';
import { StagnantCellComponent } from '../table-cell/stagnant-field-cell.component';
import { PrintAndMonitorService } from '../services/raintree/Transmission/print-and-monitor.service';
import {
  PrintAndMonitorMemberData,
  PrintAndMonitorResponseData,
} from '../services/raintree/interfaces/print-and-monitor';
import { ActivatedRoute, Router } from '@angular/router';
import { SerialNoCellComponent } from '../table-cell/serial-no-cell.component';
import { PrintAndMonitorCellComponent } from '../table-cell/print-and-monitor-cell.component';
import { WishlistDialogComponent } from '../views/common/wishlist-dialog/wishlist-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { DpSuccessMessageComponent } from '../common-component/dp-success-message/dp-success-message.component';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { StateCellComponent } from '../table-cell/state-review-table';
import { DistrictPMCellComponent } from '../table-cell/district_cell_component';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { FindDetailWishListService } from '../services/common/find-detail-wishlist.shared';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { EditContactAddressComponent } from './edit-contact-address/edit-contact-address.component';
import { PrintService } from '../services/common/print.service';
import { MasterSearchTransmissionService } from '../services/raintree/Transmission/master-search.service';
import { RefreshedDateKey } from '../enum/refresh-date';
import { ReviewDataService } from '../services/raintree/Transmission/review-data.service';
import { deleteRowData } from '../services/common/utils';
import { SearchService } from '../services/common/search.service';
import { ROUTES } from '../services/server-route';
import CryptoJS from 'crypto-js'
import { environment } from '../../environments/environment';
import { VisitComponent } from './visited/visit.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { VisitTransmissionService } from '../services/raintree/Transmission/visit-transmission.service';
import { VisitedFilterDialogComponent } from './visited-filter-dialog/visited-filter-dialog.component';

enum ReportTypes {
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  DISTRICTS = 'DISTRICTS',
  PINCODES = 'PINCODES',
  UNKNOWN = 'UNKNOWN',
}
@Component({
  selector: 'app-print-monitor',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    LoaderComponent,
    CommonModule,
    DpTableComponent,
    // PrintMonitorSecondaryTableComponent,
    InfiniteScrollModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSelectModule,
    ReactiveFormsModule,
    ClipboardModule,
    FormsModule,
    // ManageButtonComponent,
  ],
  providers: [DatePipe],
  templateUrl: './print-monitor.component.html',
  styleUrls: ['./print-monitor.component.scss', '../../styles/_dropdown.scss'],
})
export class PrintMonitorComponent implements OnInit {
  // stateName!: string;
  reports: any = [];
  public pincode: any = [];
  public districtName: any = [];
  public stateName: any = [];
  secretKey: string = environment.wsSecretKey;
  currentDistrict: string | null = null;
  // allStateReport: any;
  // allDistrictReport: any;
  constructor(
    public bottomSheet: MatBottomSheet,//EXTRA!! added for mobile view of visit component
    public dialog: MatDialog,
    private _printAndMonitorService: PrintAndMonitorService,
    private _visitTransmission: VisitTransmissionService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _toaster: ToastrService,
    private _mobileScreen: CommonUtilService,
    private toaster: ToastrService,
    private findDetailsWishListService: FindDetailWishListService,
    private printAndMonitorService: PrintAndMonitorService,
    private printService: PrintService,
    private datePipe: DatePipe,
    private masterSearchService: MasterSearchTransmissionService,
    public reviewService: ReviewDataService,
    public _searchService: SearchService
  ) { }
  breadcrumbs = ['All countries', 'India'];
  isLoading = false;
  lastRefreshedDate: any;
  memberData: any = [];
  filterData: any = []
  viewFilterOptions = [
    { id: 1, name: 'Not Added to wishlist' },
    { id: 2, name: 'Added to wishlist' },
    { id: 3, name: 'Visited' }
  ];
  viewFilterValue = new FormControl(1);
  viewFilterValuePrev = this.viewFilterValue.value;
  visitedFilters = undefined;
  address = new FormControl('');
  searchTerm = new FormControl('');
  timeout: any;
  public mobileDevice: boolean = false;
  public districtCellClicked: boolean = false;
  public stagnantCellClicked: boolean = false;
  isAllChecked: boolean = false;
  public showReportType = ReportTypes.COUNTRIES;
  pageNo: number = 0;
  isScrollable: boolean = false;
  pincodes: any = [];
  workerList: any = [];
  filterReports: any = [];
  displayHomeColumnData: any = [
    {
      id: 'stateName',
      name: 'State',
    },
    {
      id: 'total_active_count',
      name: 'Active',
    },
    {
      id: 'total_inactive_count',
      name: 'Inactive',
    },
    {
      id: 'total_stagnant_data',
      name: 'Stagnant',
    },
  ];
  displayStateColumnData: any = [
    {
      id: 'district',
      name: 'District',
    },
    {
      id: 'total_active_count',
      name: 'Active',
    },
    {
      id: 'total_inactive_count',
      name: 'Inactive',
    },

    {
      id: 'total_stagnant_data',
      name: 'Stagnant',
    },
  ];
  displayColumnData = [
    { id: 'pincode', name: 'Pincode' },
    { id: 'total_active_count', name: 'Active' },
    { id: 'total_inactive_count', name: 'Inactive' },
    { id: 'total_stagnant_data', name: 'Stagnant' },
  ];
  displayMemberColumnData: any[] = [
    {
      id: 'SL_NO',
      name: 'Serial No',
      width: ''
    },
    {
      id: 'dikshyarthi_name',
      name: 'Name',
      width: ''
    },
    {
      id: 'ritwiki_name',
      name: 'Ritwick Name',
      width: ''
    },
    {
      id: 'guardian_name',
      name: 'Guardian Name',
      width: ''
    },
    {
      id: 'initiation_date',
      name: 'Initiation Date',
      width: ''
    },
    {
      id: 'permanent_address',
      name: 'Address',
      // width: ''
    },
    {
      id: 'actions',
      name: '',
    },
  ];
  cellComponentMapAllCountry = {
    stateName: StateCellComponent,
  };
  cellComponentMapAllState = {
    district: DistrictPMCellComponent,
  };
  cellComponentMap = {
    total_stagnant_data: StagnantCellComponent,
  };
  columnConfs = {
    // actions: { cssClass: 'namewidth' },
  };
  memberCellComponentMap = {
    SL_NO: SerialNoCellComponent,
    actions: PrintAndMonitorCellComponent,
  };
  queryParams: any;
  async ngOnInit(): Promise<void> {
    this.queryParams = { ...this._activatedRoute.snapshot.queryParams };
    console.log(this.queryParams, 'querryparams........');
    this._activatedRoute.queryParams.subscribe(async (params: any) => {
      this.viewFilterValue.setValue(1);//this.filterOptions[1].id
      this.viewFilterValuePrev = this.viewFilterValue.value;
      if (params.district && this.currentDistrict != params.district) {
        this.currentDistrict = params.district;
        await this.connect()
      } else {
        this.currentDistrict = null
      }
    });
    this.mobileDevice = this._mobileScreen.isMobileDevice();
    this.isLoading = true;
    this.viewFilterValue.setValue(1);//this.filterOptions[1].id
    this.viewFilterValuePrev = this.viewFilterValue.value;
    this.addBreadCrumbs();
    this.subscribeToRouteParams();
    // this.address.valueChanges.subscribe((item: any) => {
    //   if (item.length >= 1) {
    //     this.subscribeToRouteParams();
    //   }
    // });
    this.fetchLastRefreshDate();
    // temporary websocket testing

    // await this.connect()
    this.searchTerm.valueChanges.subscribe((item: any) => {
      console.log(this.reports, this.filterReports)
      this.reports = this.filterReports
      if (item?.length > 0)
        this.onSearch(item)
    })
  }

  cleanup(ws: WebSocket): void {
    ws.removeEventListener('open', this.onOpen);
    ws.removeEventListener('message', this.onMessage);
    ws.removeEventListener('error', this.onError);
  }

  onOpen(): void {
  }

  onMessage(event: any): void {
    const message = event.data;
    if (message && message != '' && typeof message == 'string') {
      const memKeys = JSON.parse(message);
      memKeys?.length > 1
        ? memKeys.forEach((memKey: string) => {
          deleteRowData(this.memberData, 'SL_NO', memKey);
        })
        : memKeys?.length > 0
          ? deleteRowData(this.memberData, 'SL_NO', memKeys)
          : '';
    }
  }

  onError(): void {
  }

  onClose(ws: WebSocket): any {
    this.cleanup(ws);

    let router = this._router.url.split('/')
    router[1] === 'datum' && this.currentDistrict ?
      this.connect() : '' // Attempt reconnection after 5 seconds if user is on print and monitor page
  }

  async connect(): Promise<void> {
    const self = this;
    const token: any = localStorage.getItem('AccessToken');
    // const district = this.queryParams['district'];
    const encDistrict = CryptoJS.AES.encrypt(this.currentDistrict!, this.secretKey).toString();
    const encodedDistrict = encodeURIComponent(encDistrict);
    const ws = new WebSocket(`${ROUTES.WEB_SOCKET}?district=${encodedDistrict}`, token);
    ws.onmessage = (event) => self.onMessage(event);
    ws.onclose = () => self.onClose(ws);
    ws.onopen = () => self.onOpen();
    ws.onerror = () => self.onError();
  }

  fetchLastRefreshDate() {
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (refreshDate) {
      this.lastRefreshedDate = refreshDate.filter((item: any) =>
        item.configName.includes(RefreshedDateKey.AllReport)
      );
      this.lastRefreshedDate = this.datePipe.transform(
        this.lastRefreshedDate[0].date,
        'MMM d, y'
      );
    }
    this.filterReports = this.reports;
  }
  onSearch(event: any) {
    this.reports = this._searchService.filterData(
      this.reports,
      event,
      this.displayColumnData
    );
  }
  onViewSelect() {
    const currentParams = { ...this._activatedRoute.snapshot.queryParams };

    let stale = false;
    if (this.viewFilterValue.value === this.viewFilterValuePrev)
      stale = true;
    else
      this.visitedFilters = undefined;

    this.fetchReportsForMembersClick(
      currentParams['pincode'],
      currentParams['district'],
      currentParams['state'],
      true,
      stale
    );
    this.viewFilterValuePrev = this.viewFilterValue.value;
  }
  addBreadCrumbs() {
    this._activatedRoute.queryParams.subscribe((params) => {
      if (params['state'] && this.breadcrumbs.length === 2) {
        this.breadcrumbs.push(params['state']);
      }
      if (params['district'] && this.breadcrumbs.length === 3) {
        this.breadcrumbs.push(params['district']);
      }
      if (params['pincode'] && this.breadcrumbs.length === 4) {
        this.breadcrumbs.push(params['pincode']);
      }
      this.isLoading = false;
    });
  }
  onsubmit() { }
  subscribeToRouteParams(): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this._activatedRoute.queryParams.subscribe((params) => {
        const queryParamsObj: any = {};
        this.findDetailsWishListService.setVariables(
          params['state'],
          params['district']
        );
        !params['pincode'] || params['pincode'] !== 'Unknown' ? this.address.setValue('') : ''
        if (params['pincode'] || params['pincode'] === 'Unknown') {
          this.showReportType = ReportTypes.PINCODES;
          this.fetchReportsForMembersClick(
            params['state'],
            params['district'],
            params['pincode'],
            true
          );
        } else if (params['state'] && params['district']) {
          this.showReportType = ReportTypes.DISTRICTS;
          this.districtCellClicked = true;
          this.handleDistrictParams(params, queryParamsObj);
        } else if (params['state']) {
          this.showReportType = ReportTypes.STATES;

          queryParamsObj['uiState'] = params['state'];
          this.fetchReportsAllCountry(queryParamsObj);
        } else {
          this.fetchReportsAllCountry({});
        }
      });
    }, 300);
  }
  handleDistrictParams(params: any, queryParamsObj: any): void {
    queryParamsObj['uiState'] = params['state'];
    queryParamsObj['uiDistrict'] = params['district'];

    this.fetchReports(queryParamsObj);
  }
  fetchReports(queryParamsObj: any): void {
    this.isLoading = true;
    this._printAndMonitorService.fetchReports(queryParamsObj).subscribe({
      next: (response: PrintAndMonitorResponseData) => {
        this.reports = response.data[0];
        console.log(this.reports, 'reports-------->');

        this.filterReports = this.reports;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    });
  }
  fetchReportsAllCountry(queryParamsObj: any): void {
    this.isLoading = true;
    this._printAndMonitorService
      .fetchReportsAllCountry(queryParamsObj)
      .subscribe({
        next: (response: any) => {
          if (this.showReportType === 'STATES') {
            this.reports = [
              ...response.data.map((user: any) => {
                return {
                  district: user.district,
                  total_active_count: user.total_active_count,
                  total_inactive_count: user.total_inactive_count,
                  fw_pending: user.fw_pending,
                  total_stagnant_data: user.total_stagnant_data,
                };
              }),
            ];
            this.isLoading = false;
          } else {
            this.reports = [
              ...response.data.map((item: any) => {
                return {
                  stateName: item.state,
                  total_active_count: item.total_active_count,
                  total_inactive_count: item.total_inactive_count,
                  fw_pending: item.fw_pending,
                  total_stagnant_data: item.total_stagnant_data,
                };
              }),
            ];
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.toaster.error(error);
          this.isLoading = false;
        },
      });
  }
  onScrollTable() {
    if (this.isScrollable) {
      this.pageNo++;
      const currentParams = { ...this._activatedRoute.snapshot.queryParams };
      this.fetchReportsForMembersClick(
        currentParams['state'],
        currentParams['district'],
        currentParams['pincode'],
        false
      );
    }
  }
  fetchReportsForMembers(params: any, scroll: boolean): void {
    const queryParamsObjMember: any = {};
    if (params['pincode']) {
      queryParamsObjMember['pincode'] = params['pincode'];
    }
    this.isLoading = true;
    // this.stagnantCellClicked = true;
    // this.districtCellClicked = false
    this._printAndMonitorService
      .fetchReportsForMembers(
        // params['state'],
        // params['district'],
        params['pincode']
      )
      .subscribe({
        next: (response: PrintAndMonitorMemberData) => {
          // this.memberData = response.data;
          this.isLoading = false;
        },
        error: (error) => {
          this.toaster.error(error);
          this.isLoading = false;
        },
      });
  }
  onCellClick(event: any) {
    const currentParams = { ...this._activatedRoute.snapshot.queryParams };
    let newParams = {};
    if (!this.mobileDevice) {
      newParams = { pincode: event.rowData.pincode };
    } else newParams = { pincode: event };
    const queryParams = { ...currentParams, ...newParams };
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
    let queryParamsObj: any = {};

    switch (event.columnId) {
      case 'pincode':
        this.handlePincodeClick(event, queryParamsObj);
        break;
    }
  }
  onStateClick(state: string) {
    this.showReportType = ReportTypes.STATES;
    this._router.navigate([`${this._router.url}`], {
      queryParams: {
        state,
      },
    });
  }
  onDistrictClick(event: any) {
    this.districtCellClicked = true;
    let qparams: any;
    this._activatedRoute.queryParams.subscribe((params) => {
      qparams = Object.assign({}, params);
    });
    qparams.district = event.district;
    this._router.navigate([`${this._router.url.split('?')[0]}`], {
      queryParams: qparams,
    });
  }
  handleDistrictClickMob(distName: string) {
    let queryParamsObj: any = {};
    queryParamsObj.district = distName;

    this.fetchReports(queryParamsObj);
  }
  handlePincodeClick(event: any, queryParamsObj: any) {
    queryParamsObj.district = event.data.district_name;
    queryParamsObj.pincode = event.data.pincode;
    this.fetchReports(queryParamsObj);
  }
  fetchReportsForMembersClick(
    stateName: string,
    districtName: string,
    pincode: any,
    scrollable: boolean,
    stale?: boolean
  ) {
    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
    this.isLoading = true;
    let queryParamsObj: any = {};
    if (scrollable) {
      this.pageNo = 1;
      this.isScrollable = true;
    }
    queryParamsObj = {
      pincode: queryParams['pincode'],
      uiState: queryParams['state'],
      uiDistrict: queryParams['district'],
      address: this.address.value,
      pageNo: this.pageNo,
      // notAddedToWishlist: true,// true
      // pageSize: 500,
    };


    this.showReportType = ReportTypes.PINCODES;

    if (this.viewFilterValue.value !== 3) {
      // if (this.viewFilterValue.value === 1)
      //   Object.assign(queryParamsObj, {addedToWishlist: false});
      //queryParamsObj.notAddedToWishlist = false;
      if (this.viewFilterValue.value === 2)
        Object.assign(queryParamsObj, { addedToWishlist: true }, this.visitedFilters);
      //queryParamsObj.notAddedToWishlist = true;

      this._printAndMonitorService
        .fetchReportsStagnantData(queryParamsObj)
        .subscribe({
          next: (response: PrintAndMonitorMemberData) => {
            // console.log('not added to wishlist =>',queryParamsObj.notAddedToWishlist);
            // console.log('print and monitor response',response);

            if (scrollable && this.pageNo === 1 && !stale) {
              this.displayMemberColumnData = this.displayMemberColumnData.filter((item) => item.id !== 'wishlist_name');
              this.displayMemberColumnData = this.displayMemberColumnData.filter((item) => item.id !== 'pin');
              this.displayMemberColumnData.forEach((item, index) => {
                if (index !== 2 || 6 || 7)
                  item.width = '';
              });

              if (queryParamsObj.addedToWishlist) {
                this.displayMemberColumnData = [
                  ...this.displayMemberColumnData.slice(0, 5),
                  { id: 'pin', name: 'Pin', width: '90px' },
                  ...this.displayMemberColumnData.slice(5, 6),
                  { id: 'wishlist_name', name: 'Wishlist Name', width: '120px' },//new item is being added, thus the succeeding indices of the array increase by 1
                  ...this.displayMemberColumnData.slice(6)
                ]
                this.displayMemberColumnData[0].width = '140px';
                this.displayMemberColumnData[6].width = '140px';
                this.displayMemberColumnData[2].width = '180px';
                this.displayMemberColumnData[4].width = '140px';
              }
            }

            if (response.data.length === 0) {
              this.isScrollable = false;
              if (scrollable && this.pageNo === 1)
                this.memberData = [];
            } else {
              // if(this.viewFilterValue.value===2){
              //   response.data=response.data.filter((row:any)=>row.visit_count===0);
              // }
              if (this.pageNo > 1)
                this.memberData = [...this.memberData, ...response.data];
              else this.memberData = response.data;
            }
            this.isLoading = false;
          },
          error: (error) => {
            this.toaster.error(error);
            this.isLoading = false;
            if (scrollable && this.pageNo === 1)
              this.memberData = [];
          },
        });
    }
    else {

      Object.assign(queryParamsObj, this.visitedFilters);

      this._visitTransmission
        .fetchVisitDetails(queryParamsObj)
        .subscribe({
          next: (response: any) => {
            // console.log('visitDetails response =>',response);

            if (scrollable && this.pageNo === 1 && !stale) {
              this.displayMemberColumnData = this.displayMemberColumnData.filter((item) => item.id !== 'wishlist_name');
              this.displayMemberColumnData = this.displayMemberColumnData.filter((item) => item.id !== 'pin');
              this.displayMemberColumnData.forEach((item, index) => {
                if (index !== 2 || 6 || 7)
                  item.width = '';
              });

              this.displayMemberColumnData = [
                ...this.displayMemberColumnData.slice(0, 5),
                { id: 'pin', name: 'Pin', width: '90px' },
                ...this.displayMemberColumnData.slice(5, 6),
                { id: 'wishlist_name', name: 'Wishlist Name', width: '120px' },//new item is being added, thus the succeeding indices of the array increase by 1
                ...this.displayMemberColumnData.slice(6)
              ]
              this.displayMemberColumnData[0].width = '140px';
              this.displayMemberColumnData[6].width = '140px';
              this.displayMemberColumnData[2].width = '180px';
              this.displayMemberColumnData[4].width = '140px';
            }

            if (response.data.length === 0) {
              this.isScrollable = false;
              if (scrollable && this.pageNo === 1)
                this.memberData = [];
            } else {

              if (this.pageNo > 1)
                this.memberData = [...this.memberData, ...response.data];
              else this.memberData = response.data;
            }
            this.isLoading = false;
          },
          error: (error) => {
            this.toaster.error(error);
            this.isLoading = false;
            if (scrollable && this.pageNo === 1)
              this.memberData = [];
          },
        });
    }


  }
  onActionButtonClick(data: any, type: string) {
    if (type === 'wishlist') {
      const dialogRef = this.dialog.open(WishlistDialogComponent, {
        data: { type: 'pm', memberId: data.SL_NO },
      });
      dialogRef.afterClosed().subscribe((value) => {
        if (value) data.wishListId = [];
      });
    } else if (type === 'like') {
      this._printAndMonitorService
        .addToFavorites({ member: data.SL_NO })
        .subscribe({
          next: (response: any) => {
            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `'${data.dikshyatri_name}' had been added to Favourites`,
                buttonValue: 'Done',
              },
            });
          },
          error: (error) => {
            this._toaster.error(
              'You have already added this member to your selected list'
            );
          },
        });
    }
  }
  onMemberCellClick(event: any, type: any) {
    let data: any = event?.rowData ?? event;
    console.log(data, 'data');

    // console.log('onMemberCellClick->',data);//extra log for checking data for visit component

    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };

    let id = '';
    let name = '';
    let pincode = '';
    let state = '';
    let district = '';
    if (type === '') {
      id = event.rowData.SL_NO;
      name = event.rowData.dikshyarthi_name;
      pincode = event.rowData.pin;
      state = event.rowData.state_name;
      district = event.rowData.district_name;
    } else {
      id = event.SL_NO;
      name = event.dikshyarthi_name;
      pincode = event.pin;
      state = event.state_name;
      district = event.district_name;
    }
    if (event.actionType === 'wishlist' || type === 'wishlist') {
      if (data.wishlistId == null) {
        const dialogRef = this.dialog.open(WishlistDialogComponent, {
          data: {
            type: 'pm',
            memberId: id,
            pincode: pincode,
            state: state,
            district: district,
            added: this.viewFilterValue.value,
            // pin: this.pincodes,
          },
        });
        dialogRef.afterClosed().subscribe((value) => {
          if (value) deleteRowData(this.memberData, 'SL_NO', data.SL_NO);
        });
      } else {
        let queryParamsObj = {};
        queryParamsObj = {
          memKey: data.SL_NO,
          uiDistrict: district,
          uiState: state,
        };
        this.printAndMonitorService
          .checkStagnantStatus(queryParamsObj)
          .subscribe({
            next: (res) => {
              if (res) {
                res.data.length > 0
                  ? res.data.map((item: any) => {
                    return {
                      wishlistName: item.wishlistName,
                      added: item.addedBy,
                    };
                  })
                  : [];
                this.toaster.success(
                  `This member is already added in ${res.data.wishlistName} by ${res.data.addedBy}`
                );
              }
            },
          });
      }
    } else if (event.actionType === 'like' || type === 'like') {
      this.isLoading = true;
      this._printAndMonitorService
        .addToFavorites({
          member: id,
          uiState: queryParams['state'],
          uiDistrict: queryParams['district'],
        })
        .subscribe({
          next: (response: any) => {
            this.isLoading = false;
            const dialogRef = this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `'${name}' had been added to Favourites`,
                buttonValue: 'Done',
              },
            });
            dialogRef.afterClosed().subscribe(() => {
              // deleteRowData(this.memberData, 'SL_NO', data.SL_NO);
            });
          },
          error: (error) => {
            this.isLoading = false;
            this._toaster.error(
              'You have already added this member to your selected list'
            );
          },
        });
    } else if (event.actionType === 'edit' || type === 'edit') {
      this.isLoading = true;
      this.printAndMonitorService
        .getNoteDetails(type !== 'edit' ? event.rowData.SL_NO : id)
        .subscribe({
          next: (res) => {
            // console.log(event.rowData);
            // console.log(res.data);
            const dialogRef = this.dialog.open(EditContactAddressComponent, {
              data: {
                memKey: event.rowData,
                data: res.data,
                type: 'pm',
              },
            });
            this.isLoading = false;
          },
          error: (err) => {
            this.isLoading = false;
            this.toaster.error(err);
          },
        });
    }
    else if ((event.actionType === 'Add details' || 'Visit history') || (type === 'Add details' || 'Visit history')) {

      if (this._mobileScreen.isMobileDevice()) {
        const sheetRef = this.bottomSheet.open(VisitComponent, {
          data: {
            memKey: data,
            data: '',
            type: event.actionType || type,
          },
        });

        sheetRef.afterDismissed().subscribe((action: string) => {
          (action === 'refresh table') ? this.fetchReportsForMembersClick('', '', '', true, true) : null;
        });
      }
      else {
        console.log(data, 'what data contains');
        const dialogRef = this.dialog.open(VisitComponent, {
          data: {
            memKey: data,
            data: '',
            type: event.actionType || type,
          },
          disableClose: true,
          width: (data.visit_count < 3) ? '720px' : '1300px', maxWidth: '1300px',
          height: '82vh', maxHeight: '90vh',
        });

        dialogRef.afterClosed().subscribe((action: string) => {
          (action === 'refresh table') ? this.fetchReportsForMembersClick('', '', '', true, true) : null;
        });
      }
    }
  }
  openWishlistDialog(event: any, type: string) {
    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
    let id = '';
    let name = '';
    let pincode = '';
    let state = '';
    let district = '';
    if (queryParams['pincode']) {
      if (type === '') {
        id = event.rowData.SL_NO;
        name = event.rowData.dikshyatri_name;
        state = event.rowData.state_name;
        district = event.rowData.district_name;
        pincode = queryParams['pincode'] || event?.rowData.pin;
      } else {
        id = event.SL_NO;
        name = event.dikshyatri_name;
        state = event.state_name;
        district = event.district_name;
        pincode = queryParams['pincode'] || event?.pin;
      }
    }
    const dialogRef = this.dialog.open(WishlistDialogComponent, {
      data: {
        type,
        state: state || queryParams['state'],
        district: district || queryParams['district'],
        pincode: pincode,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (!value && this.showReportType === 'PINCODES') {
        const queryParams: any = {
          ...this._activatedRoute.snapshot.queryParams,
        };
        // this.fetchReportsForMembersClick(
        //   queryParams['state'],
        //   queryParams['district'],
        //   queryParams['pincode'],
        //   true
        // );
      }
    });
  }
  trackMember(index: number, item: any): any {
    return item.id || index;
  }
  onBreadcrumbClick(index: number) {
    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
    if (index > 0 && index < this.breadcrumbs.length) {
      this.breadcrumbs.splice(index + 1);
      if (index === 1) {
        this.showReportType = ReportTypes.COUNTRIES;
        delete queryParams['state'];
        delete queryParams['district'];
        this.districtCellClicked = false;
        delete queryParams['pincode'];
      }
      if (index === 2) {
        this.showReportType = ReportTypes.STATES;
        this.districtCellClicked = false;
        delete queryParams['district'];
        delete queryParams['pincode'];
      }
      if (index === 3) {
        this.showReportType = ReportTypes.DISTRICTS;
        delete queryParams['pincode'];
      }
    }
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: queryParams,
    });
  }
  printData: any = [];
  onAllselectCheckbox(data: any) { }
  // printAll() {
  //   this.isLoading = true;
  //   const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
  //   this._printAndMonitorService
  //     .fetchReportsForMembers({
  //       pincode: queryParams['pincode'],
  //       uiState: queryParams['state'],
  //       uiDistrict: queryParams['district'],
  //       printAll: true,
  //     })
  //     .subscribe({
  //       next: (response: PrintAndMonitorMemberData) => {
  //         this.printData = response.data;
  //         this.printSelected();
  //         this.isLoading = false;
  //       },
  //       error: (error) => {
  //         this.isLoading = false;
  //       },
  //     });
  // }
  onCheckboxChange(data: any) {
    this.printData = data;
  }
  onCheckboxChangeMob(data: any) {
    this.printData.push(data);
  }
  printSelected() {
    if (this.printData.length == 0) {
      return;
    }
    const queryParams: any = { ...this._activatedRoute.snapshot.queryParams };
    const subHeader = `${queryParams['pincode']}, ${queryParams['district']}, ${queryParams['state']}`;
    const header = `PRINT & MONITOR | ${subHeader}`;
    const currentDate = new Date().toISOString().split('T')[0];
    const fileName = `PRINT_MONITOR_${this.queryParams['pincode']}_${currentDate}`;
    const columns = [
      'SL NO',
      'DIKSHYARTHI NAME',
      'RITWIK NAME',
      'GUARDIAN NAME',
      'INITIATION DATE',
      'ADDRESS',
    ];
    const rows = this.printData.map((user: any) => [
      user?.SL_NO,
      user.dikshyarthi_name,
      user?.ritwiki_name,
      user?.guardian_name,
      user?.initiation_date,
      user.permanent_address,
    ]);
    const cellStyles: any = {
      0: { cellWidth: 2.0, halign: 'center', fontStyle: 'bold' },
      1: { cellWidth: 4.5 },
      2: { cellWidth: 3.0 },
      3: { cellWidth: 3.0 },
      4: { cellWidth: 2.1 },
      5: { cellWidth: 5.4 },
    };
    this.printService.printPdf(
      rows,
      columns,
      header,
      fileName,
      'p',
      'a4',
      true,
      cellStyles
    );
  }

  openFilterDialog() {
    let dialogRef = this.dialog.open(VisitedFilterDialogComponent, {
      data: { activeView: this.viewFilterValue.value },
      width: (this._mobileScreen.isMobileDevice()) ? '90vw' : '30vw'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.visitedFilters = result;
        // console.log(this.visitedFilters);
        this.fetchReportsForMembersClick('', '', '', true, true);
      }
    });
  }
}
